import { axiosClient } from '@/api/axiosClient'
import { setAdmin } from '@/app/features/admin/adminSlice'
import { logout, setAccessToken } from '@/app/features/user/authSlice'
import { setUser } from '@/app/features/user/userSlice'
import { useAppDispatch, useAppSelector } from '@/app/hooks'
import React, { useEffect, useState } from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'

function AdminProtectedRoute() {
    const dispatch = useAppDispatch()
    const [isFetched, setIsFetched] = useState(false)
    const { admin } = useAppSelector((state) => state.admin)
    const navigate = useNavigate()
    const location = useLocation()

    useEffect(() => {
        const getAdmin = async () => {
            try {
                const { data } = await axiosClient.post("admin/refresh-token", {}, {timeout: 2000})

                dispatch(setAccessToken(data?.accessToken))

                console.log(data, 'refresh-token')
                let response = await axiosClient.get("admin")
                console.log(response)
                if (response.status == 200) {
                    // setTimeout(() => {
                    dispatch(setAdmin(response.data))
                    console.log('timout')
                    setIsFetched(true)
                    // }, 5000);
                    if (location.pathname == "/login") {
                        return navigate("/")
                    }
                } else {
                    // setTimeout(() => {
                    setIsFetched(true)
                    dispatch(logout())
                    // }, 5000);
                    return navigate('/login')

                }


            } catch (error) {
                console.log(error)
                setIsFetched(true)
                return navigate('/login')
            }
        }
        getAdmin()
    }, [])

    if (!isFetched && !admin) {
        return (
            <div className='w-screen h-screen flex items-center justify-center gap-4 p-3 sm:min-w-[420px]' >
                <svg className="text-gray-700 animate-spin" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"
                    width="36" height="36">
                    <path
                        d="M32 3C35.8083 3 39.5794 3.75011 43.0978 5.20749C46.6163 6.66488 49.8132 8.80101 52.5061 11.4939C55.199 14.1868 57.3351 17.3837 58.7925 20.9022C60.2499 24.4206 61 28.1917 61 32C61 35.8083 60.2499 39.5794 58.7925 43.0978C57.3351 46.6163 55.199 49.8132 52.5061 52.5061C49.8132 55.199 46.6163 57.3351 43.0978 58.7925C39.5794 60.2499 35.8083 61 32 61C28.1917 61 24.4206 60.2499 20.9022 58.7925C17.3837 57.3351 14.1868 55.199 11.4939 52.5061C8.801 49.8132 6.66487 46.6163 5.20749 43.0978C3.7501 39.5794 3 35.8083 3 32C3 28.1917 3.75011 24.4206 5.2075 20.9022C6.66489 17.3837 8.80101 14.1868 11.4939 11.4939C14.1868 8.80099 17.3838 6.66487 20.9022 5.20749C24.4206 3.7501 28.1917 3 32 3L32 3Z"
                        stroke="currentColor" stroke-width="8" stroke-linecap="round" stroke-linejoin="round"></path>
                    <path
                        d="M32 3C36.5778 3 41.0906 4.08374 45.1692 6.16256C49.2477 8.24138 52.7762 11.2562 55.466 14.9605C58.1558 18.6647 59.9304 22.9531 60.6448 27.4748C61.3591 31.9965 60.9928 36.6232 59.5759 40.9762"
                        stroke="currentColor" stroke-width="8" stroke-linecap="round" stroke-linejoin="round" className="text-white">
                    </path>
                </svg>
                Loading...
            </div>)
    }

    if (isFetched && admin) {
        return <Outlet />
    }
}

export default React.memo(AdminProtectedRoute)